import MediaCard from './common/MediaCard'

const WhyChooseEnterpriseCard = () => {
  return (
    <MediaCard
      layout={{
        desktop: 'content-right-media-left',
        mobile: 'content-top-media-bottom',
      }}
      imageContainerWidth='50%'
      imageFitPreset='cover-right'
      image={{
        alt: 'Robot middle section',
        desktop: {
          src: '/images/new/robot-middle-cut-v2.png',
          dimensions: { width: 916, height: 982 },
        },
        mobile: {
          src: '/images/new/robot-middle-cut-mobile.png',
          dimensions: { width: 400, height: 500 },
        },
      }}
    >
      <div className='gap-2 px-4 pt-4 pb-5 ms-lg-n15 me-lg-20 py-lg-19'>
        <h3 className='fw-semibold fs-fluid-36-52 lh-105'>
          Why Choose Our <br className='d-none d-lg-block' /> Enterprise
          Solutions?
        </h3>
        <div className='fw-semibold lh-132 fs-fluid-18-28'>
          100+ banks, accountancy firms, and businesses trust our virtual office
          SaaS solutions.
        </div>
        <div className='fw-semibold lh-132 fs-fluid-16-22'>
          Our expertise in the financial sector and modern REST API enable
          seamless integration with your platform. Our integration options are
          built on experience, and a restless approach to understanding our
          Partners needs.{' '}
        </div>
      </div>
    </MediaCard>
  )
}

export default WhyChooseEnterpriseCard
